import apiClient from './apiClient';

export interface AppSetting {
  _id: string;
  key: string;
  value: any;
  description?: string;
  category: 'safety' | 'legal' | 'marketplace' | 'general';
  updatedBy?: {
    _id: string;
    username: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

class AppSettingsService {
  async getAllSettings(category?: string): Promise<AppSetting[]> {
    const params = category ? `?category=${category}` : '';
    const response = await apiClient.get(`/settings${params}`);
    return response.data.data;
  }

  async getSettingByKey(key: string): Promise<AppSetting> {
    const response = await apiClient.get(`/settings/${key}`);
    return response.data.data;
  }

  async getPublicSettings(): Promise<Record<string, any>> {
    const response = await apiClient.get('/settings/public');
    return response.data.data;
  }

  async upsertSetting(settingData: Partial<AppSetting>): Promise<AppSetting> {
    const response = await apiClient.post('/settings', settingData);
    return response.data.data;
  }

  async updateSetting(key: string, settingData: Partial<AppSetting>): Promise<AppSetting> {
    const response = await apiClient.put(`/settings/${key}`, settingData);
    return response.data.data;
  }

  async deleteSetting(key: string): Promise<void> {
    await apiClient.delete(`/settings/${key}`);
  }
}

export const appSettingsService = new AppSettingsService();
export default appSettingsService;

